// The backend's shared run contract (backend app/services/common/run_contract.py):
// POST -> 202 { run_id, status, poll_url, reused } ; GET poll_url -> the run.
// Used by System Health check runs and Marketing Intelligence analysis runs.
// Byte-identical across CA/FL/TX.
export type RunStatus = "queued" | "running" | "completed" | "completed_with_warnings" | "failed";
export type RunTrigger = "manual" | "scheduled" | "post_deploy" | "retry";

export const ACTIVE_RUN_STATUSES: readonly RunStatus[] = ["queued", "running"];

export interface RunTriggerResponse {
  run_id: number;
  status: RunStatus;
  poll_url: string;
  /** True when an identical active run was reused instead of starting a new one. */
  reused: boolean;
}

export interface RunStatusBody {
  run_id: number;
  trigger: string;
  status: RunStatus;
  requested_at?: string | null;
  started_at?: string | null;
  completed_at?: string | null;
  summary?: Record<string, unknown> | null;
  error?: string | null;
}

export interface HealthCheckRunStatus extends RunStatusBody {
  region: string;
  scope: string;
  summary?: {
    checks?: Array<{ id: number | null; region: string; check_type: string; status: string; severity: string }>;
    counts?: Record<string, number>;
    skipped?: string[];
  } | null;
}

/** 409: an active run already covers some of the requested work. */
export class RunConflictError extends Error {
  constructor(message: string, public readonly conflictingRunId: number) {
    super(message);
    this.name = "RunConflictError";
  }
}
